import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';

@Injectable()
export class HashService {

  constructor(private appConfigService: AppConfigService) {
  }

  public computeHash(companyGuid: string, email: string, password: string): string {
    const combined = `${this.appConfigService.config?.companyGuid}${email}${this.appConfigService.config.sharedSecret}${password}`.toLocaleLowerCase();
    const sha256hash = crypto.SHA256(combined);
    const tobase64hash = sha256hash.toString(crypto.enc.Base64);

    return tobase64hash;
  }
}
